module.exports = __webpack_public_path__ + "media/icons/globe-6882ffe6.svg";